'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _decisivIconixReact = require('decisiv-iconix-react');

var _decisivIconixReact2 = _interopRequireDefault(_decisivIconixReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UnstyledButton(_ref) {
  var name = _ref.name,
      rest = _objectWithoutProperties(_ref, ['name']);

  // eslint-disable-next-line no-unused-vars
  var modifiers = rest.modifiers,
      buttonProps = _objectWithoutProperties(rest, ['modifiers']);

  return _react2.default.createElement(
    'button',
    buttonProps,
    _react2.default.createElement(_decisivIconixReact2.default, { name: name })
  );
}

UnstyledButton.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string),
  name: _propTypes2.default.string.isRequired
};

UnstyledButton.defaultProps = {
  modifiers: []
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  align-items: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  height: ' + theme.dimensions.leftNavWidthCollapsed + ';\n  justify-content: center;\n  padding: 0;\n  width: ' + theme.dimensions.leftNavWidthCollapsed + ';\n\n  span {\n    opacity: 0.5;\n  }\n\n  &:hover {\n    span {\n      opacity: 1;\n    }\n  }\n';
};

var themePropTypes = {
  dimensions: _propTypes2.default.shape({
    leftNavWidthCollapsed: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ExpanderButton', (0, _styledComponents2.default)(UnstyledButton), styles, { themePropTypes: themePropTypes });


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/LeftNav/ExpanderButton.js
// module id = 1577
// module chunks = 2